import { TAB_SHOW } from '../../../../common/tabs/tabs.constants';
import { IDS } from './pnp-approval.constants';
import { getDocumentDetails, getDocumentReviewerApproverDetails } from './pnp-approval.actions';
import { getDocumentCategories, getDocumentStatuse, getDocumentTypes } from '../pnp-docs.actions';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpApproval = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, DocumentManager) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpDocument: policies.pnpDocument
            }), {
                getDocumentDetails,
                getDocumentReviewerApproverDetails,
                getDocumentCategories,
                getDocumentTypes,
                getDocumentStatuse
            })(this);


            this.getDocumentTypes('dms');
            this.getDocumentCategories();
            this.getDocumentStatuse();
        }

        this.onSelect = ({ item }) => {
            this.getDocumentReviewerApproverDetails(item.vdoId).then(() => {
                this.getDocumentDetails(item.id).then(() => {
                    $ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: IDS.app_policies_documents_approval,
                        state: [IDS.app_policies_documents_approval_details],
                        stateParams: { id: item.id }
                    });
                });
            });
        };

        this.onDownloadButton = ({ item }) => {
            DocumentManager.downloadFile(item.path);
        };

        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpApprovalFilterForm');
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
        }
    },
    template: `
        <pnp-approval-grid
            on-select="$ctrl.onSelect($event)" 
            on-download="$ctrl.onDownloadButton($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-approval-grid>
    `
};
